import { render, staticRenderFns } from "./PlatformReceiptsPaymentsStatementsDetail.vue?vue&type=template&id=b6b5798a&scoped=true&"
import script from "./PlatformReceiptsPaymentsStatementsDetail.vue?vue&type=script&lang=js&"
export * from "./PlatformReceiptsPaymentsStatementsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlatformReceiptsPaymentsStatementsDetail.vue?vue&type=style&index=0&id=b6b5798a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b5798a",
  null
  
)

export default component.exports